/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Dictionary } from '@/datamodel/dictionary'
import {
    BaseRoadmapItem,
    BeadItems,
    BigItem,
    RoadMapData,
    RoadMapItem,
    RoadMapProperties
} from './data-model'
import {
    bigColor,
    RoadType,
    TYPE_BEAD_IMG,
    TypeBead,
    TypePair
} from './data-model/types'
import { detectGoodRoads } from '@/components/desk/good-road/detect-good-roads'

/**
 * Parse the Desk Result Data into a readable Roadmap Data
 * @param strData
 */
export function parseRoadMap(strData = ''): RoadMapData {
    const TypeColor = { RED: 0, BLUE: 2 }

    const result = new RoadMapData()
    let bigRoadColumns: RoadMapItem[] = []

    const parseData = (strData = '') => {
        if (strData.length === 0) return undefined
        const strArr = strData.split('#')

        const tieMap = new Dictionary<number>()
        const super6Map = new Dictionary<number>()
        const bigItems: BigItem[] = []
        const bigeyeItems: BaseRoadmapItem[] = []
        const smallItems: BaseRoadmapItem[] = []
        const cockroachItems: BaseRoadmapItem[] = []

        const assestBead = (
            type: number,
            pair: number,
            index: number,
            isSuper6 = false,
            imageType = TYPE_BEAD_IMG.NONE
        ) => {
            const x = Math.floor(index / 6)
            const y = index % 6
            const bead: BeadItems = new BeadItems(x, y, type, pair, isSuper6)
            bead.imgType = imageType

            result.beads.push(bead)
        }

        const assestBigItemTemp = (
            index: number,
            list: BigItem[],
            mPost: Dictionary<number>,
            sPost: Dictionary<number>,
            isSuper6 = false
        ) => {
            let type = TypeBead.GREEN
            const item = result.beads[index]
            if (item.type === TypeBead.GREEN) {
                if (list.length > 0) {
                    const locationX = list.length - 1
                    const locationY = list[locationX].size - 1
                    const key = `${locationX}:${locationY}`
                    if (mPost.ContainsKey(key)) {
                        const count = mPost.Item(key) + 1
                        mPost.Add(key, count)
                    } else {
                        mPost.Add(key, 1)
                    }
                }
            } else if (item.type === TypeBead.RED) {
                type = TypeBead.RED
            } else if (item.type === TypeBead.BLUE) {
                type = TypeBead.BLUE
            }

            if (type !== TypeBead.GREEN) {
                if (list.length > 0) {
                    const lstItem = list.length - 1
                    if (list[lstItem].type === item.type) {
                        list[lstItem].addSize()
                        list[lstItem].pairs.push(item.pair)
                        // list[lstItem].isSuper6 = isSuper6
                    } else {
                        const toAdd = new BigItem(item.type, 0, 0)
                        toAdd.pairs.push(item.pair)
                        // toAdd.isSuper6 = isSuper6
                        toAdd.addSize()
                        list.push(toAdd)
                    }
                } else {
                    const toAdd = new BigItem(item.type, 0, 0)
                    toAdd.pairs.push(item.pair)
                    toAdd.addSize()
                    // toAdd.isSuper6 = isSuper6
                    list.push(toAdd)
                }

                // do super 6 big items logic here

                if (isSuper6) {
                    const locationX = list.length - 1
                    const locationY = list[locationX].size - 1
                    const key = `${locationX}:${locationY}`

                    if (sPost.ContainsKey(key)) {
                        const count = sPost.Item(key)
                        sPost.Add(key, count)
                    } else {
                        sPost.Add(key, 1)
                    }
                }
            }
        }

        const assestOtherItemsTemp = (
            startPost: number,
            list: RoadMapItem[],
            refList: RoadMapItem[]
        ) => {
            const size = refList.length
            const lasPost = size - 1
            const itemSize = refList[lasPost].size
            let type = TypeColor.RED

            if (size > 1 && itemSize > 1) {
                if (
                    itemSize - 1 < refList[lasPost - startPost].size ||
                    itemSize - 1 > refList[lasPost - startPost].size
                ) {
                    type = TypeColor.RED
                } else {
                    type = TypeColor.BLUE
                }
            } else if (itemSize === 1 && size > startPost + 1) {
                const tempSize = refList[lasPost - 1].size
                if (
                    tempSize < refList[lasPost - (startPost + 1)].size ||
                    tempSize > refList[lasPost - (startPost + 1)].size
                ) {
                    type = TypeColor.BLUE
                } else {
                    type = TypeColor.RED
                }
            } else {
                return
            }

            if (list.length > 0) {
                const tempLastPost = list[list.length - 1]
                if (type === tempLastPost.type) {
                    list[list.length - 1].addSize()
                } else {
                    const toAdd = new BaseRoadmapItem(type, 0, 0)
                    toAdd.addSize()
                    list.push(toAdd)
                }
            } else {
                const toAdd = new BaseRoadmapItem(type, 0, 0)
                toAdd.addSize()
                list.push(toAdd)
            }
        }

        /**
         * Assest the BigItems
         * @param paramList
         * @param resultingList
         * @param resultingMap
         */
        const assestBigItems = (
            paramList: RoadMapItem[],
            resultingList: BigItem[],
            resultingMap: Dictionary<number>,
            resultingS6Map: Dictionary<number>
        ) => {
            const mapItem = new Dictionary<number>()
            let offsetX = 0

            for (let i = 0; i < paramList.length; i++) {
                const item = paramList[i]
                const size = item.size
                let locationY = 0
                let locationX = i + offsetX

                for (let j = 0; j < size; j++) {
                    let key = `${locationX}:${locationY}`

                    while (mapItem.ContainsKey(key)) {
                        if (locationY < 5) {
                            locationY += 1
                            const tempKey = `${locationX}:${locationY}`
                            if (mapItem.ContainsKey(tempKey)) {
                                locationX += 1
                                locationY -= 1
                            }
                        } else if (locationY >= 5) {
                            locationY = 5
                            locationX += 1
                        }

                        key = `${locationX}:${locationY}`
                        const prevItem = resultingList[resultingList.length - 1]
                        if (locationY === 0 && prevItem.type === item.type) {
                            offsetX += 1
                        }
                    }

                    mapItem.Add(key, item.type)
                    const tieKey = `${i}:${j}`

                    const s6Key = `${i}:${j}`

                    const tempItem = new BigItem(
                        item.type,
                        locationX,
                        locationY
                    )
                    tempItem.pair = item.pairs[j]
                    // tempItem.isSuper6 = item.isSuper6
                    // tempItem.isSuper6 = false

                    if (resultingMap.ContainsKey(tieKey)) {
                        tempItem.tieSize = resultingMap.Item(tieKey)
                        tempItem.hasTie = true
                    }

                    if (resultingS6Map.ContainsKey(s6Key)) {
                        tempItem.isSuper6 = true
                    }

                    resultingList.push(tempItem)
                }
            }
        }

        /**
         * Assest the Other Items
         * @param paramList
         * @param resultingList
         */
        const assestOtherItems = (
            paramList: RoadMapItem[],
            resultingList: BaseRoadmapItem[]
        ) => {
            const mapItem = new Dictionary<number>()
            paramList.forEach((item, i) => {
                const size = item.size
                let locationY = 0
                let locationX = i

                for (let j = 0; j < size; j++) {
                    let key = `${locationX}:${locationY}`
                    while (mapItem.ContainsKey(key)) {
                        if (locationY < 5) {
                            locationY += 1
                            const tempKey = `${locationX}:${locationY}`
                            if (mapItem.ContainsKey(tempKey)) {
                                locationX += 1
                                locationY -= 1
                            }
                        } else if (locationY >= 5) {
                            locationY = 5
                            locationX += 1
                        }
                        key = `${locationX}:${locationY}`
                    }
                    mapItem.Add(key, item.type)

                    const toAdd = new BaseRoadmapItem(
                        item.type,
                        locationX,
                        locationY
                    )
                    resultingList.push(toAdd)
                }
            })
        }

        strArr.forEach((strValue, key) => {
            let value = parseInt(strValue)
            let imageType = TYPE_BEAD_IMG.NONE
            let isSuper6 = false
            const caseValue = value

            switch (caseValue) {
                case 7:
                case 71:
                case 72:
                case 73: {
                    value = 1
                    imageType = TYPE_BEAD_IMG.DRAGON_7
                    isSuper6 = true
                    if (caseValue === 71) {
                        value = 11
                    } else if (caseValue === 72) {
                        value = 12
                    } else if (caseValue === 73) {
                        value = 13
                    }
                    break
                }

                case 8:
                case 81:
                case 82:
                case 83: {
                    value = 2
                    imageType = TYPE_BEAD_IMG.BEAR_8
                    isSuper6 = true
                    if (caseValue === 81) {
                        value = 21
                    } else if (caseValue === 82) {
                        value = 22
                    } else if (caseValue === 83) {
                        value = 23
                    }
                    break
                }

                case 9:
                case 91:
                case 92:
                case 93: {
                    value = 1
                    imageType = TYPE_BEAD_IMG.BIG
                    if (caseValue === 91) {
                        value = 11
                    } else if (caseValue === 92) {
                        value = 12
                    } else if (caseValue === 93) {
                        value = 13
                    }
                    break
                }

                case 10:
                case 101:
                case 102:
                case 103: {
                    value = 1
                    imageType = TYPE_BEAD_IMG.SMALL
                    if (caseValue === 101) {
                        value = 11
                    } else if (caseValue === 102) {
                        value = 12
                    } else if (caseValue === 103) {
                        value = 13
                    }
                    break
                }
            }

            if (value < 10) value = value * 10

            let bType = Math.floor(value / 10) - 1
            const pair = value % 10
            // let bType = Math.floor(value / 10) - 1
            // const pair = value % 10

            if (bType === TypeBead.DT_TIE) {
                bType = TypeBead.GREEN
            } else if (bType === TypeBead.TIGER) {
                bType = TypeBead.BLUE
            } else if (bType === TypeBead.DRAGON) {
                bType = TypeBead.RED
            } else if (bType === TypeBead.SUPER_6) {
                isSuper6 = true
                bType = TypeBead.RED
            }

            if (bType === TypeBead.RED) {
                result.redCount += 1
            } else if (bType === TypeBead.BLUE) {
                result.blueCount += 1
            } else if (bType === TypeBead.GREEN) {
                result.tieCount += 1
            }

            if (pair === TypePair.RED) {
                result.redPairCount += 1
            } else if (pair === TypePair.BLUE) {
                result.bluePairCount += 1
            } else if (pair === TypePair.BOTH) {
                result.redPairCount += 1
                result.bluePairCount += 1
            }

            result.round += 1

            assestBead(bType, pair, key, isSuper6, imageType)
            assestBigItemTemp(key, bigItems, tieMap, super6Map, isSuper6)

            const size = bigItems.length
            if (size > 1 && bType !== TypeBead.GREEN) {
                assestOtherItemsTemp(1, bigeyeItems, bigItems)
            }
            if (size > 2 && bType !== TypeBead.GREEN) {
                assestOtherItemsTemp(2, smallItems, bigItems)
            }
            if (size > 3 && bType !== TypeBead.GREEN) {
                assestOtherItemsTemp(3, cockroachItems, bigItems)
            }
        })

        assestBigItems(bigItems, result.bigs, tieMap, super6Map)
        bigRoadColumns = bigItems
        assestOtherItems(bigeyeItems, result.bigeyes)
        assestOtherItems(smallItems, result.smalls)
        assestOtherItems(cockroachItems, result.cockroachs)
    }

    parseData(strData)

    result.goodRoads = detectGoodRoads(bigRoadColumns)

    return result
}

/**
 * Fix the Blur of Canvas
 * @param canvas
 */
const fixCanvasSize = (canvas: HTMLCanvasElement): RoadMapProperties => {
    const dpi = window.devicePixelRatio

    const styleHeight = +getComputedStyle(canvas)
        .getPropertyValue('height')
        .slice(0, -2)
    const styleWidth = +getComputedStyle(canvas)
        .getPropertyValue('width')
        .slice(0, -2)

    //  fix canvas blur
    canvas.setAttribute('height', `${styleHeight * dpi}`)
    canvas.setAttribute('width', `${styleWidth * dpi}`)

    const width = canvas.clientWidth * dpi
    const height = canvas.clientHeight * dpi

    const ctx = canvas.getContext('2d', { alpha: false })

    if (!ctx) {
        throw new Error('canvas Context Error')
    }
    ctx.imageSmoothingEnabled = false
    return new RoadMapProperties(ctx, width, height, 0, dpi)
}

/**
 * Draw the roadmap into the canvas
 * @param options
 * @param arrs
 * @param roadType
 * @param offsetY
 * @param offsetX
 */
export function drawRoadMap(
    options: RoadMapProperties | undefined,
    arrs: Array<any>,
    roadType = RoadType.BEAD,
    offsetY = 0,
    offsetX = 0,
    gameType = ''
) {
    if (!options) return

    const { colWidth, ctx, colNum, dpi } = options

    let radius: number
    if (roadType === RoadType.BEAD) {
        radius = colWidth / 2
    } else if (roadType === RoadType.BIG) {
        radius = colWidth / 4
    } else {
        radius = colWidth / 8
    }

    // color vars
    const RED = '#c70004'
    const BLUE = '#0000fe'
    const GREEN = '#00c40c'

    const count = arrs.length
    if (count === 0) {
        return
    }

    const scroll = arrs[count - 1].x - (colNum - 1)

    try {
        arrs.forEach((item, i) => {
            const { type, x, y, pair, tieSize, isSuper6, imgType } = item

            let inRange = false
            let scrollX = x

            if (i === arrs.length - 1 && options.isPre && scrollX >= scroll) {
                return
            }

            if (scrollX >= scroll) {
                inRange = true
                if (scroll > 0) {
                    scrollX = scrollX - scroll
                }

                if (scrollX > colNum - 1) {
                    return
                }
            }

            if (inRange) {
                const pointY = y * radius * 2 + offsetY
                const pointX = scrollX * radius * 2 + offsetX

                if (roadType === RoadType.BEAD) {
                    let color = RED
                    let label = ''
                    if (type === TypeBead.RED) {
                        color = RED
                        // label = '庄'
                        label = gameType === 'G002' ? '庄' : '龙'
                        if (gameType === 'G002' && isSuper6) label = '6'
                    } else if (type === TypeBead.BLUE) {
                        color = BLUE
                        // label = '閑'
                        label = gameType === 'G002' ? '閑' : '虎'
                    } else {
                        color = GREEN
                        label = '和'
                    }

                    ctx.lineWidth = options.lineWidth * dpi
                    ctx.fillStyle = color
                    // ctx.strokeStyle = '#000'
                    ctx.beginPath()
                    ctx.arc(
                        radius + pointX,
                        radius + pointY,
                        (colWidth / 2) * 0.8,
                        0,
                        2 * Math.PI
                    )
                    ctx.stroke()
                    ctx.fill()
                    ctx.closePath()

                    // const fontSize = options.fontSize * dpi

                    const drawBluePair = () => {
                        ctx.beginPath()
                        ctx.lineWidth = options.lineWidth * dpi * 1.2
                        ctx.fillStyle = BLUE
                        ctx.strokeStyle = '#fff'
                        ctx.arc(
                            radius + (pointX + radius / 2),
                            radius + (pointY + radius * 0.66),
                            (colWidth / 2) * 0.28,
                            0,
                            Math.PI * 2
                        )
                        ctx.fill()
                        ctx.stroke()
                        ctx.closePath()
                    }

                    const drawRedPair = () => {
                        ctx.lineWidth = options.lineWidth * dpi * 1.2
                        ctx.beginPath()
                        ctx.fillStyle = RED
                        ctx.strokeStyle = '#fff'
                        ctx.arc(
                            radius + (pointX - radius / 2),
                            radius + (pointY - radius * 0.66),
                            (colWidth / 2) * 0.28,
                            0,
                            Math.PI * 2
                        )
                        ctx.fill()
                        ctx.stroke()
                        ctx.closePath()
                    }

                    if (imgType === TYPE_BEAD_IMG.NONE) {
                        ctx.fillStyle = '#fff'
                        ctx.font = `${radius}px Arial`
                        ctx.textAlign = 'center'
                        ctx.textBaseline = 'middle'
                        ctx.fillText(label, radius + pointX, pointY + radius)

                        if (pair === TypePair.RED) {
                            drawRedPair()
                        } else if (pair === TypePair.BLUE) {
                            drawBluePair()
                        } else if (pair === TypePair.BOTH) {
                            drawRedPair()
                            drawBluePair()
                        }
                    } else {
                        const img = new Image()
                        img.src = ''
                        if (imgType === TYPE_BEAD_IMG.BEAR_8) {
                            img.src = require('@/assets/imgs/bear_8.png')
                        } else if (imgType === TYPE_BEAD_IMG.BIG) {
                            img.src = require('@/assets/imgs/big_tiger.png')
                        } else if (imgType === TYPE_BEAD_IMG.SMALL) {
                            img.src = require('@/assets/imgs/small_tiger.png')
                        } else if (imgType === TYPE_BEAD_IMG.DRAGON_7) {
                            img.src = require('@/assets/imgs/dragon_7.png')
                        }

                        if (img.src !== '') {
                            img.onload = () => {
                                const size = radius * 2
                                const newSize = size * 0.85 // 1% smaller
                                const offset = (size - newSize) / 2 // center adjustment
                                ctx.drawImage(
                                    img,
                                    radius + pointX - radius + offset,
                                    radius + pointY - radius + offset,
                                    newSize,
                                    newSize
                                )

                                // ctx.drawImage(
                                //     img,
                                //     radius + pointX - radius,
                                //     radius + pointY - radius,
                                //     radius * 2,
                                //     radius * 2
                                // )

                                if (pair === TypePair.RED) {
                                    drawRedPair()
                                } else if (pair === TypePair.BLUE) {
                                    drawBluePair()
                                } else if (pair === TypePair.BOTH) {
                                    drawRedPair()
                                    drawBluePair()
                                }
                            }
                        }
                    }
                } else if (roadType === RoadType.BIG) {
                    const colwidth = radius * 2
                    ctx.lineWidth = options.lineWidth * dpi

                    ctx.strokeStyle = type === bigColor.RED ? RED : BLUE
                    ctx.beginPath()
                    //  ctx.arc(radius + pointX, radius + pointY, radius - (1.5 * dpi), 0, 2 * Math.PI);
                    ctx.arc(
                        radius + pointX,
                        radius + pointY,
                        (radius - ctx.lineWidth) * 0.8,
                        0,
                        2 * Math.PI
                    )

                    if (isSuper6) {
                        ctx.fillStyle = type === bigColor.RED ? RED : BLUE
                        ctx.arc(
                            radius + pointX,
                            radius + pointY,
                            (radius - ctx.lineWidth) * 0.8,
                            0,
                            2 * Math.PI
                        )
                        ctx.fill()
                    }
                    ctx.stroke()

                    if (tieSize > 0) {
                        // draw diagonal line centered in the big circle
                        const centerX = radius + pointX
                        const centerY = radius + pointY
                        const offset = radius * 0.7

                        ctx.beginPath()
                        ctx.strokeStyle = GREEN
                        ctx.moveTo(centerX - offset, centerY + offset)
                        ctx.lineTo(centerX + offset, centerY - offset)

                        ctx.lineWidth = 2 * dpi
                        ctx.stroke()

                        ctx.fillStyle = '#000' //GREEN
                        ctx.font = `bold ${radius * 1.2}px Arial`
                        ctx.textAlign = 'center'
                        ctx.textBaseline = 'middle'
                        ctx.fillText(`${tieSize}`, centerX, centerY)

                        ctx.closePath()
                    }

                    ctx.closePath()

                    const drawBluePair = () => {
                        const centerX = radius + pointX
                        const centerY = radius + pointY
                        const bigRadius = (radius - ctx.lineWidth) * 0.8
                        const diagOffset = bigRadius / Math.sqrt(2)

                        ctx.beginPath()
                        ctx.lineWidth = options.lineWidth * dpi
                        ctx.fillStyle = BLUE
                        ctx.strokeStyle = '#fff'
                        ctx.arc(
                            centerX + diagOffset,
                            centerY + diagOffset,
                            radius * 0.38,
                            0,
                            Math.PI * 2
                        )
                        ctx.fill()
                        ctx.stroke()
                        ctx.closePath()
                    }

                    const drawRedPair = () => {
                        const centerX = radius + pointX
                        const centerY = radius + pointY
                        const bigRadius = (radius - ctx.lineWidth) * 0.8
                        const diagOffset = bigRadius / Math.sqrt(2)

                        ctx.beginPath()
                        ctx.lineWidth = options.lineWidth * dpi
                        ctx.fillStyle = RED
                        ctx.strokeStyle = '#fff'
                        ctx.arc(
                            centerX - diagOffset,
                            centerY - diagOffset,
                            radius * 0.38,
                            0,
                            Math.PI * 2
                        )
                        ctx.fill()
                        ctx.stroke()
                        ctx.closePath()
                    }

                    if (pair === TypePair.RED) drawRedPair()
                    else if (pair === TypePair.BLUE) drawBluePair()
                    else if (pair === TypePair.BOTH) {
                        drawRedPair()
                        drawBluePair()
                    }
                } else if (roadType === RoadType.BIGEYE) {
                    ctx.lineWidth = options.lineWidth * dpi
                    ctx.strokeStyle = type === bigColor.RED ? RED : BLUE
                    ctx.beginPath()
                    ctx.arc(
                        radius + pointX,
                        radius + pointY,
                        radius - 1 * dpi,
                        0,
                        2 * Math.PI
                    )
                    ctx.stroke()
                    ctx.closePath()
                } else if (roadType === RoadType.SMALL) {
                    ctx.fillStyle = type === bigColor.RED ? RED : BLUE
                    ctx.beginPath()
                    ctx.arc(
                        radius + pointX,
                        radius + pointY,
                        radius - 1 * dpi,
                        0,
                        2 * Math.PI
                    )
                    ctx.fill()
                    ctx.closePath()
                } else if (roadType === RoadType.COCKROACH) {
                    const lineWidth = options.lineWidth * dpi
                    const colwidth = radius * 2
                    ctx.lineWidth = lineWidth
                    ctx.lineCap = 'round'
                    ctx.strokeStyle = type === bigColor.RED ? RED : BLUE
                    ctx.beginPath()
                    ctx.moveTo(
                        pointX + lineWidth,
                        colwidth + pointY - lineWidth
                    )
                    ctx.lineTo(
                        pointX + colwidth - lineWidth,
                        pointY + lineWidth
                    )
                    ctx.stroke()
                    ctx.closePath()
                }
            }
        })
    } catch {
        console.log('Canvas Is Too Small Can not draw the road map')
    }

    // ctx.filter = 'none'
}

/**
 * Draw Gridlines on the canvas
 * Normal Roamap GridLines
 * @param canvas
 */
export function drawRoadMapGrid(
    canvas: HTMLCanvasElement,
    beadColCounts = 13
): RoadMapProperties | undefined {
    const dpi = window.devicePixelRatio
    const styleHeight = +getComputedStyle(canvas)
        .getPropertyValue('height')
        .slice(0, -2)
    const styleWidth = +getComputedStyle(canvas)
        .getPropertyValue('width')
        .slice(0, -2)

    //fix canvas blur
    canvas.setAttribute('height', `${styleHeight * dpi}`)
    canvas.setAttribute('width', `${styleWidth * dpi}`)

    const width = canvas.clientWidth * dpi
    const height = canvas.clientHeight * dpi

    const ctx = canvas.getContext('2d', { alpha: false })

    if (!ctx) {
        return undefined
    }

    ctx.imageSmoothingEnabled = false

    const lineWidth = 0.5 * dpi
    ctx.lineWidth = lineWidth
    ctx.beginPath()
    ctx.rect(0, 0, width, height)
    ctx.fillStyle = '#ffffff'
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)'
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    // const colHeght = height / 6;
    // const colwidth = colHeght;
    // const colCount = Math.floor(width / colwidth);

    ctx.beginPath()
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)'
    ctx.lineWidth = lineWidth

    const mCWidth = height / 12.0

    const mColCount = parseInt(`${width / (mCWidth > 0 ? mCWidth : 0.1)}`)

    for (let i = 0; i <= mColCount; i++) {
        let pointX = i * mCWidth
        if (i == 0) {
            pointX = pointX + lineWidth / 2
        }

        if (i < beadColCounts * 2) {
            if (i % 2 == 0) {
                ctx.moveTo(pointX, 0)
                ctx.lineTo(pointX, height)
            }
        } else {
            ctx.moveTo(pointX, 0)
            ctx.lineTo(pointX, height)
        }

        if (i <= 12) {
            let pointY = i * mCWidth
            if (i == 0) {
                pointY = pointY + lineWidth / 2
            }

            if (i % 2 == 0) {
                ctx.moveTo(0, pointY)
                ctx.lineTo(width, pointY)
            } else {
                ctx.moveTo(beadColCounts * 2 * mCWidth, pointY)
                ctx.lineTo(width, pointY)
            }
        }
    }
    ctx.stroke()
    ctx.closePath()

    return new RoadMapProperties(ctx, width, height, mCWidth, dpi)
}

export function drawRoadMapGrid1(
    canvas: HTMLCanvasElement
): RoadMapProperties | undefined {
    const { ctx, dpi, width, height } = fixCanvasSize(canvas)
    const lineWidth = 0.5 * dpi
    ctx.lineWidth = lineWidth
    ctx.beginPath()
    ctx.rect(0, 0, width, height)
    ctx.fillStyle = '#ffffff'
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)'
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)'
    ctx.lineWidth = lineWidth

    const mCWidth = height / 12
    const mColNo = width / mCWidth

    if (height > 0 && width > 0) {
        for (let i = 0; i <= mColNo; i++) {
            const pointX = i * mCWidth
            ctx.moveTo(pointX, 0)
            ctx.lineTo(pointX, height)
            if (pointX < height) {
                const pointY = pointX
                ctx.moveTo(0, pointY)
                ctx.lineTo(width, pointY)
            }
        }
    }

    ctx.stroke()
    ctx.closePath()
    return new RoadMapProperties(ctx, width, height, mCWidth * 2, dpi)
}

export function drawRoadMapGrid2(
    canvas: HTMLCanvasElement
): RoadMapProperties | undefined {
    const { ctx, dpi, width, height } = fixCanvasSize(canvas)

    const lineWidth = 0.5 * dpi
    ctx.beginPath()
    ctx.rect(0, 0, width, height)
    ctx.fillStyle = '#ffffff'
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)'
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)'
    ctx.lineWidth = lineWidth

    const mCWidth = height / 12
    const mColNo = width / mCWidth

    for (let i = 0; i <= mColNo; i++) {
        const pointX = i * mCWidth
        ctx.moveTo(pointX, 0)
        ctx.lineTo(pointX, height)
        ctx.moveTo(pointX + mCWidth / 2, mCWidth * 6)
        ctx.lineTo(pointX + mCWidth / 2, height)

        if (pointX < height) {
            const pointY = pointX
            ctx.moveTo(0, pointY)
            ctx.lineTo(width, pointY)
            if (i >= 6) {
                ctx.moveTo(0, pointY + mCWidth / 2)
                ctx.lineTo(width, pointY + mCWidth / 2)
            }
        }
    }
    ctx.stroke()
    ctx.closePath()

    return new RoadMapProperties(ctx, width, height, mCWidth, dpi)
}

export function drawRoadMapGridV1(
    canvas: HTMLCanvasElement
): RoadMapProperties | undefined {
    const { ctx, dpi, width, height } = fixCanvasSize(canvas)

    const lineWidth = 0.5 * dpi
    ctx.beginPath()
    ctx.rect(0, 0, width, height)
    ctx.fillStyle = '#ffffff'
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)'
    ctx.fill()
    ctx.stroke()
    ctx.closePath()

    ctx.beginPath()
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)'
    ctx.lineWidth = lineWidth

    const mCWidth = height / 10
    const mColNo = width / mCWidth

    for (let i = 0; i <= mColNo; i++) {
        const pointX = i * mCWidth
        ctx.moveTo(pointX, 0)
        ctx.lineTo(pointX, mCWidth * 6)
        if (i < 6) {
            ctx.moveTo(0, pointX + mCWidth)
            ctx.lineTo(width, pointX + mCWidth)
        }
        // ctx.lineTo(pointX, height)
        // ctx.moveTo(pointX + mCWidth / 2, mCWidth * 6)
        // ctx.lineTo(pointX + mCWidth / 2, height)

        // if (pointX < height) {
        //     const pointY = pointX
        //     ctx.moveTo(0, pointY)
        //     ctx.lineTo(width, pointY)
        //     if (i >= 6) {
        //         ctx.moveTo(0, pointY + mCWidth / 2)
        //         ctx.lineTo(width, pointY + mCWidth / 2)
        //     }
        // }
    }

    const _mcw = Math.floor(Math.abs(mCWidth * 6 - height) / 6)
    const _mcn = Math.floor(width / _mcw)
    for (let i = 0; i <= _mcn; i++) {
        const pointX = i * _mcw
        ctx.moveTo(pointX, mCWidth * 6)
        ctx.lineTo(pointX, height)

        if (i < 6) {
            ctx.moveTo(0, pointX + mCWidth * 6)
            ctx.lineTo(width, pointX + mCWidth * 6)
        }
    }

    ctx.stroke()
    ctx.closePath()

    return new RoadMapProperties(ctx, width, height, mCWidth, dpi)
}

/**
 * Draw Grid Single
 * @param canvas
 */
export function drawSingleGridMap(
    canvas: HTMLCanvasElement,
    colors?: { stroke?: string; fill?: string }
): RoadMapProperties | undefined {
    const { ctx, dpi, width, height } = fixCanvasSize(canvas)

    if (!ctx) {
        return undefined
    }

    const border = 1 * dpi
    // border
    ctx.beginPath()
    ctx.rect(0, 0, width, height)
    if (colors && colors.fill) {
        ctx.fillStyle = colors.fill
    } else {
        ctx.fillStyle = '#ccc'
    }
    ctx.fill()
    ctx.closePath()

    // background
    ctx.beginPath()
    ctx.rect(border, border, width - border * 2, height - border * 2)

    if (colors && colors.fill) {
        ctx.fillStyle = colors.fill
    } else {
        ctx.fillStyle = '#fff'
    }
    ctx.fill()
    ctx.closePath()

    const lineWidth = 0.5 * dpi

    ctx.beginPath()

    if (colors && colors.stroke) {
        ctx.strokeStyle = colors.stroke
    } else {
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)'
    }

    ctx.lineWidth = lineWidth

    const mCWidth = height / 6

    const mColCount = parseInt(`${width / (mCWidth > 0 ? mCWidth : 0.1)}`)

    for (let i = 0; i <= mColCount; i++) {
        let pointX = i * mCWidth
        if (i === 0) {
            pointX = pointX + lineWidth / 2
        }
        ctx.moveTo(pointX, 0)
        ctx.lineTo(pointX, height)
        if (i <= 6) {
            let pointY = i * mCWidth
            if (i === 0) {
                pointY = pointY + lineWidth / 2
            }
            ctx.moveTo(0, pointY)
            ctx.lineTo(width, pointY)
        }
    }
    ctx.stroke()
    ctx.closePath()

    return new RoadMapProperties(ctx, width, height, mCWidth, dpi)
}

export function getRoadMapScrolledData(options: {
    roadmapData: RoadMapData
    beadCol: number
    bigCol: number
    bigeyeCol: number
    smallCol: number
    cocRoachCol: number
}): {
    beads: BeadItems[]
    bigs: BigItem[]
    bigeyes: BaseRoadmapItem[]
    smalls: BaseRoadmapItem[]
    cockRoaches: BaseRoadmapItem[]
} {
    const result: {
        beads: BeadItems[]
        bigs: BigItem[]
        bigeyes: BaseRoadmapItem[]
        smalls: BaseRoadmapItem[]
        cockRoaches: BaseRoadmapItem[]
    } = {
        beads: [],
        bigs: [],
        bigeyes: [],
        smalls: [],
        cockRoaches: []
    }

    const brr: {
        type: 'beads' | 'bigs' | 'bigeyes' | 'smalls' | 'cockroach'
        data: any[]
    }[] = [
        { type: 'beads', data: options.roadmapData.beads },
        { type: 'bigs', data: options.roadmapData.bigs },
        { type: 'bigeyes', data: options.roadmapData.bigeyes },
        { type: 'smalls', data: options.roadmapData.smalls },
        { type: 'cockroach', data: options.roadmapData.cockroachs }
    ]

    brr.forEach(xp => {
        const count = xp.data.length
        let colNum = 1

        if (count === 0) {
            return
        }

        if (xp.type === 'beads') colNum = options.beadCol
        else if (xp.type === 'bigs') colNum = options.bigCol
        else if (xp.type === 'bigeyes') colNum = options.bigeyeCol
        else if (xp.type === 'smalls') colNum = options.smallCol
        else if (xp.type === 'cockroach') colNum = options.cocRoachCol

        const arrs: any = xp.data

        const scroll = arrs[count - 1].x - (colNum - 1)
        const isPre = false

        arrs.forEach((item: any, i: number) => {
            const { type, x, y, pair, tieSize, isSuper6 } = item

            let inRange = false
            let scrollX = x

            if (i === arrs.length - 1 && isPre && scrollX >= scroll) {
                return
            }

            if (scrollX >= scroll) {
                inRange = true
                if (scroll > 0) {
                    scrollX = scrollX - scroll
                }

                if (scrollX > colNum - 1) {
                    return
                }
            }

            if (inRange) {
                const pointY = y
                const pointX = scrollX

                if (xp.type === 'beads') {
                    result.beads.push(
                        new BeadItems(pointX, pointY, type, pair, isSuper6)
                    )
                } else if (xp.type === 'bigs') {
                    const bigItem = new BigItem(type, pointX, pointY)
                    bigItem.pair = pair
                    bigItem.tieSize = tieSize
                    bigItem.hasTie = tieSize > 0
                    bigItem.isSuper6 = isSuper6
                    result.bigs.push(bigItem)
                } else if (xp.type === 'bigeyes') {
                    const bigeyeItem = new BaseRoadmapItem(type, pointX, pointY)
                    result.bigeyes.push(bigeyeItem)
                } else if (xp.type === 'smalls') {
                    const smallItem = new BaseRoadmapItem(type, pointX, pointY)
                    result.smalls.push(smallItem)
                } else if (xp.type === 'cockroach') {
                    const cockroachItem = new BaseRoadmapItem(
                        type,
                        pointX,
                        pointY
                    )
                    result.cockRoaches.push(cockroachItem)
                }
            }
        })
    })

    return result
}

/**
 * Draw Grid Single
 * @param canvas
 */
export function drawSingleGridMap8(
    canvas: HTMLCanvasElement,
    colors?: { stroke?: string; fill?: string },
    brow = 9
): RoadMapProperties | undefined {
    const { ctx, dpi, width, height } = fixCanvasSize(canvas)

    if (!ctx) {
        return undefined
    }

    const border = 1 * dpi
    // border
    ctx.beginPath()
    ctx.rect(0, 0, width, height)
    if (colors && colors.fill) {
        ctx.fillStyle = colors.fill
    } else {
        ctx.fillStyle = '#ccc'
    }
    ctx.fill()
    ctx.closePath()

    // background
    ctx.beginPath()
    ctx.rect(border, border, width - border * 2, height - border * 2)

    if (colors && colors.fill) {
        ctx.fillStyle = colors.fill
    } else {
        ctx.fillStyle = '#fff'
    }
    ctx.fill()
    ctx.closePath()

    const lineWidth = 0.5 * dpi

    ctx.beginPath()

    if (colors && colors.stroke) {
        ctx.strokeStyle = colors.stroke
    } else {
        ctx.strokeStyle = 'rgba(0, 0, 0, 0.25)'
    }

    ctx.lineWidth = lineWidth

    const mCWidth = height / 6

    // const mColCount = parseInt(`${width / (mCWidth > 0 ? mCWidth : 0.1)}`)
    const bw = mCWidth * brow

    for (let i = 0; i <= brow; i++) {
        let pointX = i * mCWidth
        if (i === 0) {
            pointX = pointX + lineWidth / 2
        }
        ctx.moveTo(pointX, 0)
        ctx.lineTo(pointX, height)
        if (i <= 6) {
            let pointY = i * mCWidth
            if (i === 0) {
                pointY = pointY + lineWidth / 2
            }
            ctx.moveTo(0, pointY)
            ctx.lineTo(bw, pointY)
        }
    }

    const oCWidth = height / 9
    const pl = Math.floor((width - bw) / oCWidth)
    const cbrow = pl > 0 ? pl : 1

    for (let i = 0; i <= cbrow; i++) {
        const pointX = i * oCWidth + bw
        ctx.moveTo(pointX, 0)
        ctx.lineTo(pointX, height)
        if (i <= 9) {
            let pointY = i * oCWidth
            if (i === 0) {
                pointY = pointY + lineWidth / 2
            }
            ctx.moveTo(bw, pointY)
            ctx.lineTo(width, pointY)
        }
    }

    ctx.stroke()
    ctx.closePath()

    return new RoadMapProperties(ctx, width, height, mCWidth, dpi)
}
